<template>
	<div
		class="questions-page__wrapper mt-2"
		:style="{ padding: question.is_owner ? '12px 0 0 0 ' : '12px 0 12px 0' }"
	>
		<div class="questions-page__wrapper__user-wrapper">
			<div class="questions-page__wrapper__user-wrapper__user-info">
				<Avatar :size="52" :avatar="question.user.logo" :borderRadius="'square'" />
        <div  class="questions-page__wrapper__user-wrapper__info d-flex flex-column justify-space-between">
          <h4 class="questions-page__wrapper__user-wrapper__user-info__name">
            {{ question.user.name }}
          </h4>
          <span class="questions-page__wrapper__time">
         {{ timeAgo(question.created_at) }}
        </span>
        </div >
      </div>
			<button
          v-if="question.is_like_enabled"
				@click="toggleUpvote(question.qna_question_id)"
				class="questions-page__wrapper__user-wrapper__like-button"
				type="button"
			>
				<Icon type="like" :size="16" :color="isVote ? 'var(--vote_bar_tint)' : '#9b9b9b'" />
				<span :style="{ color: isVote ? 'var(--vote_bar_tint)' : '#9b9b9b' }">{{ voteCount }}</span>
			</button>
		</div>
		<div class="questions-page__wrapper__question">
			{{ question.qna_question_text }}
		</div>
		<div v-if="question.is_owner" class="questions-page__wrapper__approval-section">
			<h2
				:style="{ color: statusColor }"
				class="questions-page__wrapper__approval-section__status"
			>
				{{ statusQuestion }}
			</h2>
			<button @click="toggleDeleteQuestion(question.qna_question_id)" type="button">
				<Icon color="var(--button-icon-tint)" type="delete" :size="24" />
			</button>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'QuestionCard',
	data() {
		return {
			isVote: this.question.is_upvoted || false,
			voteCount: this.question.upvote_count ?? 0,
			isVoting: false,
		}
	},
	props: {
		question: {
			type: Object,
			default: () => ({}),
		},
	},
	components: { Avatar },
	computed: {
    ...mapGetters('auth', ['profile']),
    statusQuestion() {
      switch (this.question.status){
        case 2 :{
          return 'Waiting for review'
        }
        case 3 :{
          return 'Declined'
        }
        default:
          return 'Approved'
      }
    },
		statusColor() {
			switch (this.question.status) {
				case 1:
					return '#10C491'
				case 2:
					return '#9B9B9B'
				case 3:
					return '#FF3B30'
				default:
					return '#000000'
			}
		},
	},
	methods: {
		...mapActions('event', [
			'getSessionQuestions',
			'upvoteSessionQuestion',
			'deleteUpvoteSessionQuestion',
			'deleteSessionQuestion',
		]),
    timeAgo(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const now = new Date()
      const seconds = Math.floor((now - date) / 1000)

      const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
      }

      if (seconds < 60) return `${seconds}s ago`

      for (const [key, value] of Object.entries(intervals)) {
        const count = Math.floor(seconds / value)
        if (count >= 1) return `${count}${key[0]} ago`
      }
    },
		async toggleDeleteQuestion(id) {
			try {
				await this.deleteSessionQuestion(id)
				this.$emit('updateList')
			} catch (error) {
				console.error(e)
			}
		},

		async toggleUpvote(id) {
			if (this.isVoting) return

			this.isVoting = true
			const prevVote = this.isVote
			const prevCount = this.voteCount

			try {
				if (!prevVote) {
					this.isVote = true
					this.voteCount = prevCount + 1

					await this.upvoteSessionQuestion({
						qna_upvote_id: this.$route.query.qna_id,
						qna_question_id: id,
						user_id: this.profile.user_id,
					})
				} else {
					this.isVote = false
					this.voteCount = Math.max(0, prevCount - 1)
					await this.deleteUpvoteSessionQuestion(id)
				}
			} catch (e) {
				this.isVote = prevVote
				this.voteCount = prevCount
				console.error(e)
			} finally {
				this.isVoting = false
			}
		},
	},
}
</script>

<style lang="scss">
.questions-page {
  font-family: 'Inter', sans-serif !important;
  background-color: transparent !important;
  max-width: 555px;
  width: 100%;
  &__pagination {
    width: 100%;
    background-color: #f2f2f2 !important;
  }
  &__wrapper {
    display: flex;
    border-radius: 8px;
    flex-direction: column;
    border: 1px solid #e2e2e2;
    background-color: #fff;
    max-width: 555px;
    width: 100%;
    gap: 12px;
    &__time{
      color: var(--company-position-large);
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      letter-spacing: 0;
    }
    &__approval-section {
      border-top: 1px solid #e2e2e2;
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 48px;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0;
      &__status {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: 0;
      }
    }
    &__question {
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0;
      padding: 0 12px;
      color: #4a4a4a;
    }
    &__user-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0 12px;
      &__info{
        height: 46px;
      }
      &__like-button {
        display: flex;
        gap: 2px;
        align-items: center;
        justify-content: center;
        height: 33px;
        width: 67px;
        border-radius: 32px;
        background-color: #f3f3f6;
      }
      &__user-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        width: 100%;
        &__name {
          font-weight: 700;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: 0;
          color: var(--username-category-title);
        }
      }
    }
  }
}
</style>
